@if (isReady()) {
  <div
    [id]="containerId"
    class="rich-text-editor-container my-4"
    [class.rich-text-editor-disabled]="disabled()"
  >
    @if (isLabelVisible()) {
      <div class="flex items-center gap-2 mb-4">
        @if (customTranslationName(); as customName) {
          <div>{{ labelPrefix() }}{{ customName }}</div>
        } @else {
          <div>
            {{ labelPrefix()
            }}{{ translations() | translateDirectus: 'name' : true : resolvedLanguage() }}
          </div>
        }
        @if (tooltipKey(); as currentTooltipKey) {
          <app-directus-tooltip
            [tooltipKey]="currentTooltipKey"
            tooltipStyleClass="tooltip-bg-second-level"
          ></app-directus-tooltip>
        }
      </div>
    }
    <p-editor
      #editor
      [ngModel]="content()"
      (ngModelChange)="onContentChange($event)"
      [readonly]="disabled()"
      [formats]="[
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'list',
        'align',
        'color',
        'background',
      ]"
      [modules]="editorModules()"
    >
      <ng-template #header>
        <div class="flex justify-between items-center">
          <span>
            <span class="ql-formats">
              <button
                class="ql-undo"
                type="button"
                [title]="'textEditor.undo' | transloco"
              ></button>
              <button
                class="ql-redo"
                type="button"
                [title]="'textEditor.redo' | transloco"
              ></button>
            </span>
            <span class="ql-formats" id="editor-text-selection">
              <select class="ql-header">
                <option value="1">{{ 'textEditor.text.h1' | transloco }}</option>
                <option value="2">{{ 'textEditor.text.h2' | transloco }}</option>
                <option value="3">{{ 'textEditor.text.h3' | transloco }}</option>
                <option selected>{{ 'textEditor.text.normal' | transloco }}</option>
              </select>
            </span>
            <span class="ql-formats">
              <select class="ql-align">
                <option selected></option>
                <option value="center"></option>
                <option value="right"></option>
                <option value="justify"></option>
              </select>
            </span>
            <span class="ql-formats">
              <ng-container
                *ngTemplateOutlet="
                  colorSelect;
                  context: {
                    $implicit: 'ql-color',
                    title: 'textEditor.textColor' | transloco,
                  }
                "
              ></ng-container>
              <ng-container
                *ngTemplateOutlet="
                  colorSelect;
                  context: {
                    $implicit: 'ql-background',
                    title: 'textEditor.backgroundColor' | transloco,
                  }
                "
              ></ng-container>
            </span>
            <!-- eslint-disable @angular-eslint/template/elements-content -->
            <span class="ql-formats">
              <button class="ql-bold" type="button"></button>
              <button class="ql-italic" type="button"></button>
              <button class="ql-underline" type="button"></button>
              <button class="ql-strike" type="button"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered" type="button"></button>
              <button class="ql-list" value="bullet" type="button"></button>
            </span>
            <span class="ql-formats">
              <button
                class="ql-clean"
                type="button"
                [title]="'textEditor.clear' | transloco"
              ></button>
            </span>
            <!-- eslint-enable @angular-eslint/template/elements-content -->
          </span>

          @if (!disabled()) {
            <span class="ql-formats">
              <p-button
                (click)="confirmReset()"
                [label]="'textEditor.reset' | transloco"
                [pTooltip]="'textEditor.reset.tooltip' | transloco"
                tooltipPosition="top"
                styleClass="editor-reset-button"
                data-testid="editor-reset-button"
                severity="secondary"
              />
            </span>
          }
        </div>

        <ng-template #colorSelect let-selectClass let-title="title">
          <select [class]="selectClass" [title]="title">
            <option selected></option>
            @for (color of colors; track color.value) {
              <option [value]="color.value"></option>
            }
          </select>
        </ng-template>
      </ng-template>
    </p-editor>

    @if (shouldDisplaySaveButton()) {
      <div class="flex justify-end items-center mt-6">
        <p-button
          (click)="saveTemplate()"
          [disabled]="isSaveDisabled()"
          [loading]="isSaving()"
          [label]="'common.save' | transloco"
          [attr.data-testid]="'save-button-' + key()"
          appConfirmStepLeaveDirective
        />
      </div>
    }
  </div>
}
